export default __webpack_public_path__ + "static/insta-hotels-6-fab0d267ecd3ef5024651e9e4ade5b52.jpg";